const { coordsDistance, convertFromUTC, weekDaySelected, convertFromLocal, isClientSide, calculateDistance } = require('./utils')
const { isInside } = require('./timetable')
const traccarHelper = require('./traccar')

async function calculatePartialTrip (device, startDate, endDate, route, t, traccarInstance) {
  let isPartialInside = false
  const tripStart = new Date(t.startTime)
  const tripEnd = new Date(t.endTime)

  if (startDate.getTime() > endDate.getTime()) {
    if (tripStart.getTime() < endDate.getTime() &&
        tripEnd.getTime() > endDate.getTime()) {
      // Trip starts inside time period and ends outside time period
      if (!route && device) {
        const allInOneData = await traccarHelper.getAllInOne(traccarInstance, startDate, endDate, [device], true, false, false, false, undefined, undefined, 5, 1, undefined, true)
        route = allInOneData.route
      }
      const routeInside = route.filter(p => new Date(p.fixTime).getTime() < new Date(endDate.toUTCString()).getTime() && new Date(p.fixTime).getTime() > new Date(t.startTime).getTime() && t.deviceId === p.deviceId)
      updateTrip(device, t, routeInside)
      t.endTime = endDate.toISOString().replace('Z', '+0000')
      t.endTimeIsOut = true
      isPartialInside = true
    }

    if (tripStart.getTime() < startDate.getTime() &&
        new Date(t.endTime).getTime() > startDate.getTime()) {
      // Trip starts outside time period and ends inside time period
      if (!route && device) {
        const allInOneData = await traccarHelper.getAllInOne(traccarInstance, startDate, endDate, [device], true, false, false, false, undefined, undefined, 5, 1, undefined, true)
        route = allInOneData.route
      }
      const routeInside = route.filter(p => new Date(p.fixTime).getTime() > startDate.getTime() && new Date(p.fixTime).getTime() < new Date(t.endTime).getTime() && t.deviceId === p.deviceId)
      updateTrip(device, t, routeInside)
      t.startTime = startDate.toISOString().replace('Z', '+0000')
      t.startTimeIsOut = true
      isPartialInside = true
    }
  } else {
    if (tripStart.getTime() < startDate.getTime() &&
        tripEnd.getTime() > startDate.getTime()) {
      // Trip starts outside time period and ends inside time period
      if (!route && device) {
        const allInOneData = await traccarHelper.getAllInOne(traccarInstance, startDate, endDate, [device], true, false, false, false, undefined, undefined, 5, 1, undefined, true)
        route = allInOneData.route
      }
      const routeInside = route.filter(p => new Date(p.fixTime).getTime() > new Date(startDate.toUTCString()).getTime() && new Date(p.fixTime).getTime() < new Date(t.endTime).getTime() && t.deviceId === p.deviceId)
      updateTrip(device, t, routeInside)
      t.startTime = startDate.toISOString().replace('Z', '+0000')
      t.startTimeIsOut = true
      isPartialInside = true
    }

    if (tripStart.getTime() < endDate.getTime() &&
        tripEnd.getTime() > endDate.getTime()) {
      // Trip starts inside time period and ends outside time period
      if (!route && device) {
        const allInOneData = await traccarHelper.getAllInOne(traccarInstance, startDate, endDate, [device], true, false, false, false, undefined, undefined, 5, 1, undefined, true)
        route = allInOneData.route
      }
      const routeInside = route.filter(p => new Date(p.fixTime).getTime() < endDate.getTime() && new Date(p.fixTime).getTime() > new Date(t.startTime).getTime() && t.deviceId === p.deviceId)
      updateTrip(device, t, routeInside)
      t.endTime = endDate.toISOString().replace('Z', '+0000')
      t.endTimeIsOut = true
      isPartialInside = true
    }
  }
  return isPartialInside
}

function isPartialInsideTimetable (t, userData, route) {
  if (weekDaySelected(new Date(t.startTime), userData.weekDays)) {
    const startDateLocal = new Date(convertFromUTC(t.startTime, userData.user.attributes.timezone).toISOString().split('T')[0] + ' ' + userData.dayHours.startTime)
    const endDateLocal = new Date(convertFromUTC(t.startTime, userData.user.attributes.timezone).toISOString().split('T')[0] + ' ' + userData.dayHours.endTime)

    const startDate = isClientSide() ? startDateLocal : convertFromLocal(startDateLocal, userData.user.attributes.timezone)
    const endDate = isClientSide() ? endDateLocal : convertFromLocal(endDateLocal, userData.user.attributes.timezone)

    return calculatePartialTrip(undefined, startDate, endDate, route, t)
  }

  return false
}

async function getDataByDay (device, date, data, userData, traccarInstance) {
  const startDateLocal = new Date(convertFromUTC(date, userData.user.attributes.timezone).toISOString().split('T')[0] + ' 00:00:00')
  const endDateLocal = new Date(convertFromUTC(date, userData.user.attributes.timezone).toISOString().split('T')[0] + ' 23:59:59')
  const startDate = isClientSide() ? startDateLocal : convertFromLocal(startDateLocal, userData.user.attributes.timezone)
  const endDate = isClientSide() ? endDateLocal : convertFromLocal(endDateLocal, userData.user.attributes.timezone)

  const tripsByDay = []
  if (data.trips) {
    const filteredTrips = data.trips.filter(t => new Date(t.endTime) > startDate && new Date(t.startTime) < endDate)
    tripsByDay.push(...filteredTrips.map(t => { return { ...t } }))

    for (const t of tripsByDay) {
      await calculatePartialTrip(device, startDate, endDate, data.route, t, traccarInstance)
    }
  }

  const stopsByDay = []
  if (data.stops) {
    const filteredStops = data.stops.filter(t => new Date(t.endTime) > startDate && new Date(t.startTime) < endDate)
    stopsByDay.push(...filteredStops.map(t => { return { ...t } }))
  }

  const routeByDay = data.route ? data.route.filter(p => (new Date(p.fixTime) > startDate && new Date(p.fixTime) < endDate)) : []

  const refuelingPositionsByDay = data.refuelingPositions ? data.refuelingPositions.filter(p => (new Date(p.date) > startDate && new Date(p.date) < endDate)) : []

  const zoneInOutDayData = data.zoneInOutData
    ? data.zoneInOutData.filter(z => (!z.inTime || (new Date(z.inTime.fixTime) < endDate)) &&
      (!z.outTime || (new Date(z.outTime.fixTime) > startDate)))
    : []

  return { tripsByDay, stopsByDay, routeByDay, refuelingPositionsByDay, zoneInOutDayData }
}

function isValidAvgSpeed (kms, startTime, endTime) {
  const totalTime = new Date(endTime).getTime() - new Date(startTime).getTime()
  const avgSpeed = (kms / 1000) / (totalTime / (1000 * 60 * 60))
  return avgSpeed < 200
}

function getKms (trips) {
  const odometerKms = trips.length > 0 ? trips[trips.length - 1].endOdometer - trips[0].startOdometer : 0
  return odometerKms > 0 && isValidAvgSpeed(odometerKms, trips[0].startTime, trips[trips.length - 1].endTime) ? odometerKms : trips.filter(t => t.distance > 0).reduce((a, b) => a + b.distance, 0)
}

function isInsideTimetable (t, userData) {
  return isInside(t.startTime, t.endTime, userData)
}

function updateTrip (device, t, route) {
  route = route.filter(p => p && p.attributes.ignition)
  if (!route.length) { return }
  const distance = calculateDistance(route, false) * 1000
  t.distance = distance
  t.duration = new Date(route[route.length - 1].fixTime).getTime() - new Date(route[0].fixTime).getTime()
  t.maxSpeed = route.reduce((a, b) => Math.max(a, b.speed), 0)
  t.averageSpeed = distance > 0 ? ((route.reduce((a, b) => a + b.speed, 0)) / route.length) : 0
  t.startOdometer = device && !device.attributes['report.ignoreOdometer'] && route[0].attributes.odometer ? route[0].attributes.odometer : route[0].attributes.totalDistance
  t.endOdometer = device && !device.attributes['report.ignoreOdometer'] && route[route.length - 1].attributes.odometer ? route[route.length - 1].attributes.odometer : route[route.length - 1].attributes.totalDistance
}

function getUncompletedTrip (device, deviceRoute, deviceTrips) {
  if (deviceRoute.length && deviceTrips.length && deviceRoute[deviceRoute.length - 1].attributes.ignition) {
    const uncompletedTripRoute = deviceRoute.filter(p => p.attributes.ignition && new Date(p.fixTime).getTime() > new Date(deviceTrips[deviceTrips.length - 1].endTime).getTime())
    if (uncompletedTripRoute.length) {
      return calculateTrip(device, uncompletedTripRoute)
    }
  }
}

function calculateTrip (device, route) {
  console.log('route', route.length)
  const startPos = route[0]
  const endPos = route[route.length - 1]

  return {
    deviceId: device.id,
    deviceName: device.name,
    distance: calculateDistance(route, device.attributes['report.ignoreOdometer']) * 1000,
    averageSpeed: Math.round((route.map(p => p.speed).reduce((a, b) => a + b, 0)) / route.length),
    maxSpeed: route.map(p => p.speed).reduce(function (a, b) { return Math.max(a, b) }),
    spentFuel: 0,
    startOdometer: startPos.attributes.odometer || startPos.attributes.totalDistance,
    endOdometer: endPos.attributes.odometer || endPos.attributes.totalDistance,
    startPositionId: startPos.id,
    endPositionId: endPos.id,
    startLat: startPos.latitude,
    startLon: startPos.longitude,
    startTime: startPos.fixTime,
    startAddress: startPos.address,
    endLat: endPos.latitude,
    endLon: endPos.longitude,
    endTime: endPos.fixTime,
    endAddress: endPos.address,
    endTimeIsOut: true,
    duration: new Date(endPos.fixTime).getTime() - new Date(startPos.fixTime).getTime(),
    driverUniqueId: null,
    driverName: null
  }
}

function getTripIdleTime (trip, idleEvents) {
  const tripStartDate = new Date(trip.startTime)
  const tripEndDate = new Date(trip.endTime)
  const idleEventsInsideTrip = idleEvents.filter(i => tripStartDate < new Date(i.position.fixTime) && tripEndDate > new Date(i.position.fixTime))
  return idleEventsInsideTrip.reduce((a, b) => a + b.idleTime, 0)
}

function calculateStopDuration (stop) {
  const totalStopTime = new Date(stop.endTime) - new Date(stop.startTime)
  if (totalStopTime < stop.engineHours) return 0
  return totalStopTime - (stop.engineHours > 0 ? stop.engineHours : 0)
}

const maxDistanceDiff = 10000

function shouldRecalculate (trip, route) {
  if (route && route.length) {
    if (!trip.distance) {
      return true
    }
    if (route[0].protocol === 'osmand' && route[0].attributes.odometer) {
      const positions = route.filter(p => p.deviceId === trip.deviceId &&
        new Date(p.fixTime).getTime() >= new Date(trip.startTime).getTime() &&
        new Date(p.fixTime).getTime() <= new Date(trip.endTime).getTime())
      if (positions.length) {
        const totalDistance = positions[positions.length - 1].attributes.totalDistance - positions[0].attributes.totalDistance
        return trip.distance < (totalDistance - maxDistanceDiff)
      }
    }
  }
  return false
}

function getTripTotalKms (trip, stop, route) {
  // we need to add stop kms to ensure that the total kms for the day, calculated with the odometer difference, will be equal to the sum of kms of all trips
  const stopKms = stop &&
      !route.find(p => p.attributes.putAccumulators) && (stop.endOdometer - stop.startOdometer)
  let distance = trip.distance + (stop && stopKms > 0 ? stopKms : 0)
  if (shouldRecalculate(trip, route)) {
    distance = 0
    const positions = route.filter(p => p.deviceId === trip.deviceId &&
      new Date(p.fixTime).getTime() >= new Date(trip.startTime).getTime() &&
      new Date(p.fixTime).getTime() <= new Date(trip.endTime).getTime())

    let current = null
    for (const p of positions) {
      if (current) {
        distance += coordsDistance(parseFloat(current.longitude), parseFloat(current.latitude),
          parseFloat(p.longitude), parseFloat(p.latitude))
      }
      current = p
    }
  }
  return distance / 1000
}

function calculateMultiDayTrips (trips, route, tripsByDay, fromByDay, toByDay, devices) {
  const startsOutside = trips.filter(t => (new Date(t.startTime) < fromByDay && new Date(t.endTime) > fromByDay))
  if (startsOutside.length > 0) {
    tripsByDay.push(calculateTrip(devices.find(d => d.id === startsOutside[0].deviceId),
      route.filter(p => new Date(p.fixTime) >= fromByDay &&
            new Date(p.fixTime) <= new Date(startsOutside[0].endTime))))
  }

  const endsOutside = trips.filter(t => (new Date(t.startTime) < toByDay && new Date(t.endTime) > toByDay))
  if (endsOutside.length > 0) {
    tripsByDay.push(calculateTrip(devices.find(d => d.id === endsOutside[0].deviceId),
      route.filter(p => new Date(p.fixTime) >= new Date(endsOutside[0].startTime) &&
            new Date(p.fixTime) <= toByDay)))
  }
}

exports.isInsideTimetable = isInsideTimetable
exports.isPartialInsideTimetable = isPartialInsideTimetable
exports.getDataByDay = getDataByDay
exports.getKms = getKms
exports.calculatePartialTrip = calculatePartialTrip
exports.calculateTrip = calculateTrip
exports.getTripIdleTime = getTripIdleTime
exports.calculateStopDuration = calculateStopDuration
exports.getUncompletedTrip = getUncompletedTrip
exports.getTripTotalKms = getTripTotalKms
exports.calculateMultiDayTrips = calculateMultiDayTrips
